import { concat } from 'lodash'
import { http } from 'utils'
import Vue from 'vue'

const defaultPagination = {
  current_page: 1,
  from: 1,
  last_page: 1,
  next_page_url: null,
  per_page: 10,
  prev_page_url: null,
  to: 1,
  total: 0
}

// Our stars state.
const state = {
  sport: [],
  theme: [],
  industry: [],
  club: [],
  packages: [],
  categories: [],
  league: [],
  pagination: {
    sport: defaultPagination,
    club: defaultPagination,
    industry: defaultPagination,
    league: defaultPagination,
    theme: defaultPagination
  }
}

// Our stars state getters.
const getters = {
  haveNoMoreTags: (state) => (type) => {
    return state.pagination[type].current_page >= state.pagination[type].last_page ||
      state.pagination[type].total === 0
  },

  sanitizedPackages: (state) => {
    return state.packages.map((object) => {
      return { id: object.id, text: object.name }
    })
  },

  sanitizedCategories: (state) => {
    const categories = state.categories.map((object) => {
      return { id: object.id, text: object.name }
    })
    categories.push({ id: 'all', text: 'All Categories' })
    return categories
  },

  sanitizedTags: (state) => (type) => {
    return state[type].map((object) => {
      return { id: object.id, text: object.name, parent_id: object.parent_id }
    })
  }
}

// Our stars actions
const actions = {
  getPackages ({ commit }) {
    return http.get('/packages').then((response) => {
      commit('SET_PACKAGES', response.data)
    })
  },

  getCategories ({ commit }) {
    return http.get('/categories').then((response) => {
      commit('SET_CATEGORIES', response.data)
    })
  },

  getTags ({ commit }, params) {
    return http.get('/tags', { params }).then((response) => {
      commit('SET_TAGS', { type: params.type, data: response.data.data })
      commit('SET_TAGS_PAGINATION', { type: params.type, data: response.data.meta })
      return response
    })
  },

  getNextTags ({ commit, state, getters }, params = {}) {
    if (getters.haveNoMoreTags(params.type)) {
      return Promise.reject(new Error('There are no more tags to load.'))
    }

    params.page = state.pagination[params.type].current_page + 1

    return http.get(`/tags`, { params })
      .then((response) => {
        commit('ADD_TAGS', { type: params.type, data: response.data.data })
        commit('SET_TAGS_PAGINATION', { type: params.type, data: response.data.meta })

        return response
      })
  }
}

// Our stars state mutations.
const mutations = {
  SET_PACKAGES (state, packages) {
    state.packages = packages
  },

  SET_CATEGORIES (state, categories) {
    state.categories = categories
  },

  SET_TAGS (state, { type, data }) {
    Vue.set(state, type, data)
  },

  ADD_TAGS (state, { type, data }) {
    Vue.set(state, type, concat(state[type], data))
  },

  SET_TAGS_PAGINATION (state, { type, data }) {
    Vue.set(state.pagination, type, data)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
